<template>
  <v-dialog
    :content-class="$vuetify.breakpoint.mdAndUp ? 'secondary-dialog-on-desktop' : ''"
    persistent
    v-model="open"
    max-width="600px">
    <v-card color="white">
      <v-card-title class="text-element" >
          <div>
            <v-icon class="black--text" dark left>{{this.icon}}</v-icon>
            {{this.title}}
          </div>
          <v-spacer />
          <v-btn @click="close" icon ><v-icon>fa-times</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="text-element pt-6 pb-2">
        <div v-html="message"></div>
      </v-card-text>
      <v-card-actions >
<v-row style="margin: 0; padding: 0;">
          <v-spacer/>
          <v-btn @click="confirm" depressed>Komplette Liste</v-btn>
          <v-btn @click="dontConfirm" depressed color="primary">Nur bestellte Artikel</v-btn>
</v-row>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PrintOrderDialog extends Vue {
  private isOnlyInfo: boolean= false;
  private icon: string='fa fa-info';
  private title: string ='title';
  private message: string ='message';
  private color: string = 'orange';
  private open: boolean = false;

  private closeForm:any;

  private confirmationCallback: any | undefined;
    private noConfirmationCallback: any | undefined;
  private isConformation: boolean = false;

  public showDialog(completeListCallback: () => void,  onlyPositionsCallback: () => void): void {
      this.isOnlyInfo = false;
      this.confirmationCallback = completeListCallback;
      this.noConfirmationCallback = onlyPositionsCallback;
      this.title = "Druck";
      this.message = "<p>Es wurden bereits Bestellmengen eingegeben. Soll die komplette Bestelliste gedruckt werden, oder nur die Liste der bestellten Artikel?</p>"
      this.isConformation = true;
      this.show('far fa-question-circle', this.title, this.message, '');
  }
  private show(icon: string, title: string, message: string, color: string): void {
      this.icon = icon;
      this.title = title;
      this.message = message;
      this.color = color;
      this.open = true;
  }
  private dontConfirm(): void{
      if (this.noConfirmationCallback) {
          this.noConfirmationCallback();
      }

      this.noConfirmationCallback = undefined;
      this.close();
  }

  private close(){
      this.$emit('DialogClose');
      this.open = false;
  }
  private confirm(): void{
      if (this.confirmationCallback) {
          this.confirmationCallback();
      }
      this.confirmationCallback = undefined;
      this.close();
  }

  private badgeStyle(color: string): string {
      if (color) {
          return `background-color: ${color} !important;`;
      }
      return '';
  }
}
</script>

<style>
.text-element {
  word-break: break-word;
  -moz-hyphens: auto;
}
</style>
